module.exports = __webpack_public_path__ + "media/Video 98.5c0785c1.mp4";